require('./RAContributionBarEnd.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

class RAContributionBarEnd extends React.Component {
    render() {
        const { position, color, text, height, bottomCircular, topCircular } = this.props;
        const className = classnames('ra-contribution-bar-end', {
            'ra-contribution-bar-end__start': position === 'start',
            'ra-contribution-bar-end__end': position === 'end',
        });

        return (
            <div className={className} style={{ borderColor: color, height }}>
                <div className="ra-contribution-bar-end__container">
                    <div className="ra-contribution-bar-end__text">{text}</div>
                    <div
                        className="ra-contribution-bar-end__circle"
                        style={{ bottom: bottomCircular, top: topCircular }}
                    >
                        <div className="ra-contribution-bar-end__circle-center" style={{ backgroundColor: color }} />
                    </div>
                </div>
            </div>
        );
    }
}

RAContributionBarEnd.propTypes = {
    position: PropTypes.oneOf(['start', 'end']).isRequired,
    color: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    bottomCircular: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    topCircular: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

module.exports = RAContributionBarEnd;
